<template>
    <div class="side-nav-logo">
        <router-link to="/">
            <div class="logo logo-white" style="background-image: url('img/logo.png')"></div>
        </router-link>
        <div class="mobile-toggle side-nav-toggle" @click.prevent="navToogle">
            <i class="ti-arrow-left"></i>
        </div>

    </div>
</template>

<script>
    import {TOOGLE_SIDENAV} from "../../store/actions/app";
    export default {
        name: "side-nav-logo",
        
        methods: {
          //  navToogle: function (event) {
            navToogle: function () {
                this.$store.commit(TOOGLE_SIDENAV);
            }
        },
    }
</script>

<style scoped lang="scss">
    .side-nav .side-nav-inner .side-nav-logo {
        background: #fff;
        border-bottom: 1px solid #e6ecf5;
        border-right: 1px solid #e6ecf5;
         >a {
            max-width: 200px;
            .logo {
                background-size: auto 38px;
            }
        }
    }

    .is-collapsed {
        .side-nav {
            .side-nav-inner {
                .side-nav-logo {
                    > a {
                        .logo-white {
                            background-image: url('~/img/logo-sm.png') !important;
                        }
                    }
                }
            }
            &:hover {
                .side-nav-logo {
                    a {
                        .logo {
                            width: 200px;
                        }

                        .logo-white {
                            background-image: url('~/img/logo.png') !important;
                        }
                    }
                }
            }
        }


    }

</style>